import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export function trackUserStatus(date: string, offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'OfferOwnerIsOnline_sopr',
    category: 'Chat',
    label: date,
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
